import { render } from "./DeleteButton.vue?vue&type=template&id=379dd114&scoped=true"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"

import "./DeleteButton.vue?vue&type=style&index=0&id=379dd114&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379dd114"]])

export default __exports__